import '~/sass/pages/offers.scss';
import { initOffers } from '@/components/offers-extent';

const { $ } = window;

// eslint-disable-next-line no-unused-vars
function initSwipe() {
  let carShow1 = true;
  $('.unit-list a').on('click', () => {
    // const Athis = $(this);
    if (carShow1 === false) {
      $('#unit-1').fadeIn(500);
      $('#unit-2').hide();
      carShow1 = true;
    } else {
      $('#unit-1').hide();
      $('#unit-2').fadeIn(500);
      carShow1 = false;
    }
  });
}

$(document).ready(() => {
  // console.log('brand-news init');
  // initSwipe();
  initOffers();
});
